<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <!-- 全局弹窗系统 - 基于优先级只显示一个弹窗 -->
    <globalCheckAccountVue />
    <globalCheckPhoneVue />
    <SystemNoticeDialog />
  </div>
</template>

<script>
import globalCheckAccountVue from './components/globalCheckAccount.vue'
import globalCheckPhoneVue from './components/globalCheckPhone.vue'
import SystemNoticeDialog from './components/dialog/SystemNoticeDialog.vue'

export default {
  name: 'App',
  components: {
    globalCheckAccountVue,
    globalCheckPhoneVue,
    SystemNoticeDialog
  },

  mounted() {
    this.getPageWidth()
    window.addEventListener('resize', this.getPageWidth)
  },

  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('resize', this.getPageWidth);
  },

  watch: {
    '$route': {
      handler(route) {
        // 等待路由真正初始化完成（不是默认的 / 路径，或者有路由名称）
        if (route.path !== '/' || route.name) {
          this.handleRouteReady();
        }
      },
      immediate: true // 组件创建时立即执行一次
    },
    '$store.state.user.schoolInfo.domain': {
      handler(val) {
        val && this.$store.dispatch('globalCheck/methodSetDetaultPassword')
      },
      immediate: true
    }
  },

  methods: {
    handleRouteReady() {
      // 路由准备完成后的逻辑
      this.initializeApp();
    },

    initializeApp() {
      // 检查URL参数
      const urlParams = new URLSearchParams(window.location.search);
      const shouldIgnoreMobileDetection = urlParams.get('ignore') === 'true';

      // 如果有ignore参数，直接忽略移动端检测
      if (shouldIgnoreMobileDetection) {
        console.log('检测到ignore参数，忽略移动端检测');
        // 删除URL参数
        const url = new URL(window.location);
        url.searchParams.delete('ignore');
        window.history.replaceState({}, document.title, url.pathname + url.search);
        // 直接跳过移动端检测逻辑
      } else {
        // 只有在根目录时检测移动端访问，如果是移动端则跳转到手机端欢迎页面
        // 检查是否禁用了移动端检测
        const disableMobileDetection = localStorage.getItem('disableMobileDetection');
        console.log('移动端检测状态:', {
          path: this.$route.path,
          isMobile: this.isMobile(),
          disableMobileDetection: disableMobileDetection,
          shouldRedirect: this.$route.path === '/' && this.isMobile() && !disableMobileDetection
        });

        if (this.$route.path === '/' && this.isMobile() && !disableMobileDetection) {
          console.log('检测到移动设备访问根路径，跳转到移动端页面');
          this.$router.replace("/m_index");
          return;
        }
      }

      // 路由必须有name，并且不是超管端才调用
      if (this.$route.name && !this.$route.fullPath.includes('/background/')) {
        // alert(JSON.stringify(this.$route)) // 移除调试用的alert
        this.$store.dispatch('getStuTitleUrl')
      }

      // 在应用初始化时执行全局检查
      // 确保用户已登录且有token的情况下才执行检查
      // 超管端不执行全局检查
      if (this.$store.getters.token && this.$store.state.user.userInfo && Object.keys(this.$store.state.user.userInfo).length > 0 && !this.$route.path.includes('/background/')) {
        // 使用setTimeout确保应用初始化完成后再执行检查
        setTimeout(() => {
          this.$store.dispatch('globalCheck/performGlobalCheck');
        }, 200);
      }
    },

    isMobile() {
      const userAgent = navigator.userAgent;

      // 排除平板设备
      if (userAgent.match(/(iPad|tablet)/i)) {
        return false;
      }

      // 检测手机设备
      let flag = userAgent.match(
        /(phone|pod|iPhone|iPod|Android.*Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },

    getPageWidth() {
      document
        .querySelector('body')
        .style.setProperty('--page-width', window.innerWidth + 'px')
    },
  },
}
</script>

<style>
#app {
  font-family: "Avenir, Helvetica, Arial, sans-serif";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333;
  height: 100%;
}

.el-tabs__nav-wrap::after {
  background-color: #f6f6f6 !important;
}
</style>
